import React, { useEffect, useState } from 'react'
import CustomSelect, { CustomSelectOption } from '@components/CustomSelect'
import type {
  AppointmentInterviewResource,
  ClinicPatientInterviewResource,
  InterviewQuestionOptionsResource,
} from '@entities/api/Interview'
import dayjs from '@utils/dayjs'
import { useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  itemName: string | null
  appointment: AppointmentInterviewResource
  patient: ClinicPatientInterviewResource
  required: boolean
  options?: InterviewQuestionOptionsResource | null
}

const YearMonth: React.FC<Props> = ({ prefix, itemName, appointment, patient, required }) => {
  const thisMonth = dayjs.tz(appointment.start_date).date(1)
  const birthday = dayjs.tz(patient.birthday ?? '')
  const { register, watch, setValue } = useFormContext()
  const dateName = `${prefix}.value`
  const dateStr = watch(dateName)
  const date = dateStr ? dayjs.tz(dateStr) : null
  const [year, setYear] = useState(() => (date ? date.year() : thisMonth.year()))
  const [month, setMonth] = useState(() => (date ? date.month() : thisMonth.month()))
  useEffect(() => {
    setValue(dateName, dayjs().year(year).month(month).date(1).format('YYYY-MM-DD'))
  }, [year, month])

  const errorPrefix = `${itemName ? `${itemName}について、` : ''}`

  const yearOptions: CustomSelectOption[] = Array.from(
    { length: thisMonth.year() - birthday.year() + 1 },
    (_, i) => {
      const y = birthday.year() + i
      return { value: String(y), label: String(y) }
    }
  )

  const monthOptions: CustomSelectOption[] = Array.from({ length: 12 }, (_, i) => ({
    value: String(i),
    label: String(i + 1),
  }))

  const handleChangeYear = (value: string) => {
    setYear(parseInt(value, 10))
  }

  const handleChangeMonth = (value: string) => {
    setMonth(parseInt(value, 10))
  }

  return (
    <div className="row">
      <input
        ref={register({
          required: required && `${errorPrefix}年月を選択してください`,
        })}
        type="hidden"
        name={dateName}
      />
      <div className="col-auto form-group form-inline pr-1">
        <div className="input-group">
          <CustomSelect
            value={String(year)}
            onChange={handleChangeYear}
            options={yearOptions}
            title="年を選択"
          />
          <div className="input-group-append">
            <span className="input-group-text border-0 bg-white">年</span>
          </div>
        </div>
      </div>
      <div className="col-auto form-group form-inline pl-0">
        <div className="input-group">
          <CustomSelect
            value={String(month)}
            onChange={handleChangeMonth}
            options={monthOptions}
            title="月を選択"
          />
          <div className="input-group-append">
            <span className="input-group-text border-0 bg-white">月 ごろ</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default YearMonth
